let dropboxAppKey = null;
let dropboxDotNetHelper = null;

window.initializeDropboxPicker = async (dotNetRef, appKey) => {
    dropboxDotNetHelper = dotNetRef;
    dropboxAppKey = appKey;

    console.log("Dropbox Picker config from .NET", {
        appKey: dropboxAppKey
    });

    try {
        await loadDropboxScript(appKey);
        console.log("Dropbox Picker initialized successfully");
    } catch (error) {
        console.error("Failed to initialize Dropbox Picker:", error);
        if (dropboxDotNetHelper) {
            dropboxDotNetHelper.invokeMethodAsync("HandlePickerError", error.message || "Failed to initialize Dropbox Picker");
        }
    }
};

function loadDropboxScript(appKey) {
    return new Promise((resolve, reject) => {
        // Check if already loaded
        if (window.Dropbox) {
            resolve();
            return;
        }

        // Check if script tag already exists
        if (document.getElementById('dropboxjs')) {
            // Wait for it to load
            const checkInterval = setInterval(() => {
                if (window.Dropbox) {
                    clearInterval(checkInterval);
                    resolve();
                }
            }, 100);
            
            setTimeout(() => {
                clearInterval(checkInterval);
                reject(new Error("Dropbox SDK failed to load after 10 seconds"));
            }, 10000);
            return;
        }

        const script = document.createElement('script');
        script.id = 'dropboxjs';
        script.src = 'https://www.dropbox.com/static/api/2/dropins.js';
        script.setAttribute('data-app-key', appKey);
        script.type = 'text/javascript';
        
        script.onload = () => {
            // Wait a bit for Dropbox SDK to initialize
            setTimeout(() => {
                if (window.Dropbox) {
                    resolve();
                } else {
                    reject(new Error("Dropbox object not available after script load"));
                }
            }, 500);
        };
        
        script.onerror = () => reject(new Error("Failed to load Dropbox script"));
        
        document.head.appendChild(script);
    });
}

window.openDropboxPicker = async (allowMultiple = true, allowFolders = false) => {
    if (!window.Dropbox) {
        const message = "Dropbox SDK not loaded. Please refresh the page and try again.";
        console.error(message);
        if (dropboxDotNetHelper) {
            dropboxDotNetHelper.invokeMethodAsync("HandlePickerError", message);
        }
        return;
    }

    if (!dropboxAppKey) {
        const message = "Dropbox app key is missing. Check configuration.";
        console.error(message);
        if (dropboxDotNetHelper) {
            dropboxDotNetHelper.invokeMethodAsync("HandlePickerError", message);
        }
        return;
    }

    try {
        const options = {
            success: async (files) => {
                console.log("Dropbox files selected:", files);

                const processedFiles = [];
                let skippedFolderCount = 0;

                for (const doc of files) {
                    // Folders cannot be uploaded — the Dropbox Chooser returns the folder object
                    // itself, not its contents. Always skip folder entries regardless of allowFolders.
                    if (doc.isDir) {
                        skippedFolderCount++;
                        continue;
                    }

                    const mimeType = getDropboxMimeTypeFromExtension(doc.name);

                    // Convert preview link to direct download link if needed
                    let downloadLink = doc.link;
                    if (downloadLink && downloadLink.includes('www.dropbox.com') && !downloadLink.includes('dl=1')) {
                        // Convert preview link to direct download link
                        downloadLink = downloadLink.replace('dl=0', 'dl=1');
                        if (!downloadLink.includes('dl=1')) {
                            downloadLink += (downloadLink.includes('?') ? '&' : '?') + 'dl=1';
                        }
                    }

                    processedFiles.push({
                        id: doc.id || doc.link,
                        name: doc.name,
                        mimeType: mimeType,
                        sizeBytes: doc.bytes || 0,
                        link: downloadLink,
                        isFolder: false
                    });
                }

                if (processedFiles.length === 0 && files.length > 0) {
                    const warning = skippedFolderCount > 0
                        ? "Please select individual files instead of folders. Navigate into a folder and select the files you want to upload."
                        : "No supported files were found in the selection.";
                    console.warn(warning, files);
                    if (dropboxDotNetHelper) {
                        await dropboxDotNetHelper.invokeMethodAsync("HandlePickerError", warning);
                    }
                    return;
                }

                if (dropboxDotNetHelper) {
                    await dropboxDotNetHelper.invokeMethodAsync("HandleFilesSelected", processedFiles);
                }
            },
            cancel: () => {
                console.log("User cancelled the Dropbox picker");
                if (dropboxDotNetHelper) {
                    dropboxDotNetHelper.invokeMethodAsync("HandleFilesSelected", []);
                }
            },
            linkType: allowFolders ? "preview" : "direct",
            multiselect: allowMultiple,
            folderselect: allowFolders,
            extensions: ['.pdf', '.doc', '.docx', '.txt', '.png', '.jpg', '.jpeg']
        };

        window.Dropbox.choose(options);
    } catch (error) {
        console.error("Failed to open Dropbox Picker:", error);
        if (dropboxDotNetHelper) {
            dropboxDotNetHelper.invokeMethodAsync("HandlePickerError", error.message || "Failed to open Dropbox Picker");
        }
    }
};

function getDropboxMimeTypeFromExtension(filename) {
    const extension = filename.toLowerCase().split('.').pop();
    const mimeTypes = {
        'pdf': 'application/pdf',
        'png': 'image/png',
        'jpg': 'image/jpeg',
        'jpeg': 'image/jpeg',
        'doc': 'application/msword',
        'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'txt': 'text/plain'
    };
    return mimeTypes[extension] || 'application/octet-stream';
}

window.cleanupDropboxPicker = () => {
    dropboxDotNetHelper = null;
    dropboxAppKey = null;
};